// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  base_url: 'https://api.thequantedge.com/api/',
  // tool_api_base_url: "http://54.149.29.137:4756/",
  tool_api_base_url: 'https://tools.thequantedge.com/api/',
  device_token: 'tQe_NG_app_19_'+ (new Date().getTime()).toString(),
  device_type: 'web'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
